import React, { useState } from 'react';
import { Grid, PageHeader, Stack } from 'library/ui';
import FailedPayments from './Components/FailedPayments';
import PaymentsSummary from './Components/PaymentsSummary';
import PaymentMethodsSection from './Components/PaymentMethodsSection';
import MicrodepositsEntry from './Components/MicrodepositsEntry';
import InvoiceDownload from './Components/business/InvoiceDownload';
import PaymentLocationQRCodes from './Components/PaymentLocationQRCodes';
import PaymentFaq from './Components/PaymentFaq';
import LocationDiscounts from './Components/business/LocationDiscounts';
import { PermissionType, useUserContext } from 'UserContext';
import DuePayments from './Components/DuePayments';
import FeeFreeShiftsSection from './Components/business/FeeFreeShiftsSection';

const Payments = () => {
    const { hasPermission, user } = useUserContext();
    const [paymentRefreshKey, setPaymentRefreshKey] = useState(0);

    const canManagePayments = hasPermission(PermissionType.ManagePayments);
    const isManualPayer = user?.is_manual_payer;
    const showPaymentMethods = canManagePayments && !isManualPayer;

    const onPaymentsRetried = () => setPaymentRefreshKey((key) => key + 1);

    return (
        <Stack gap="md">
            <PageHeader title="Payments" />
            {canManagePayments && <MicrodepositsEntry />}
            {canManagePayments && <PaymentsSummary refreshKey={paymentRefreshKey} />}
            {showPaymentMethods && (
                <FailedPayments refreshKey={paymentRefreshKey} onPaymentsRetried={onPaymentsRetried} />
            )}
            {canManagePayments && (
                <Grid columns={2} collapseAt="md" gap="md">
                    <DuePayments maxRows={2} refreshKey={paymentRefreshKey} />
                    <InvoiceDownload />
                </Grid>
            )}
            {canManagePayments && <FeeFreeShiftsSection />}
            {showPaymentMethods && <PaymentMethodsSection />}
            <Grid columns={2} collapseAt="md" gap="md">
                <PaymentFaq />
                <PaymentLocationQRCodes />
            </Grid>
            <LocationDiscounts />
        </Stack>
    );
};

export default Payments;
